import { useNavigate } from "react-router-dom";
import "../../styles/home/hero.css";

const Hero = () => {
  const navigate = useNavigate();

  const handleExplore = () => {
    navigate("/visualizations");
  };

  return (
    <section className="hero">
      <div className="hero-heading-container">
        <h1 className="hero-heading">Learn Visually.</h1>
        <h1 className="hero-heading">Understand Deeply.</h1>
      </div>

      <p className="hero-description">
        VisualLab helps you understand complex concepts through step-by-step
        visual explanations.
      </p>

      <button onClick={handleExplore} className="primary-btn">
        Explore Visualizations
      </button>
    </section>
  );
};

export default Hero;
